import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Icon } from '@mui';
import { verifyPermissions } from '@utils/permission-utils';
import { renderEmailSettingsValue } from '@utils/settings-utils';
import './email.scss';

const MenuItem = ({ emailSettings, item }) => {
  if (!verifyPermissions(item.permissions)) {
    return null;
  }

  const row1 = renderEmailSettingsValue(emailSettings, item.type, item.row1);
  const row2 = renderEmailSettingsValue(emailSettings, item.type, item.row2);

  return (
    <div styleName="menu-item-container">
      <Link
        to={`/settings/email/${item.type}`}
        styleName="menu-item-wrapper"
      >
        <div styleName="menu-item">
          <div styleName="title">
            {item.label}
          </div>
          <div styleName="row">
            {row1}
          </div>
          {row1 !== 'Off' && (
            <div styleName="row">
              {row2}
            </div>
          )}
        </div>
        <div styleName="chevron">
          <Icon aria-hidden="true">chevron_right</Icon>
        </div>
      </Link>
    </div>
  );
};

MenuItem.propTypes = {
  emailSettings: PropTypes.object,
  item: PropTypes.object
};

export default MenuItem;
